<template>
  <div class="material-picker">
    <div class="picker-row">
      <el-select v-model="selectedUrl" filterable clearable placeholder="选择素材" @change="onSelect" @visible-change="onVisibleChange" style="flex:1">
        <el-option v-for="m in filteredMaterials" :key="m.id" :label="m.name" :value="m.url">
          <div style="display:flex;align-items:center;gap:8px">
            <img v-if="/\.(png|jpg|jpeg|gif|webp|svg)/i.test(m.url)" :src="m.url" style="width:32px;height:32px;object-fit:cover;border-radius:4px" />
            <span v-else style="font-size:20px;width:32px;text-align:center">{{ isAudio(m.url)?'音':(isVideo(m.url)?'影':'档') }}</span>
            <span>{{ m.name }}</span>
            <span style="color:#999;font-size:12px">{{ m.category }}</span>
          </div>
        </el-option>
      </el-select>
      <el-button size="small" @click="showUpload" icon="el-icon-upload">上传</el-button>
    </div>
    <div class="preview-row" v-if="value">
      <el-image
        v-if="isImage(value)"
        class="material-preview-image"
        :src="value"
        fit="cover"
        :preview-src-list="[value]"
        :z-index="5000"
        title="点击预览大图"
      >
        <div slot="error" class="material-preview-error">图片加载失败</div>
      </el-image>
      <span v-else class="material-file-preview">{{ isAudio(value) ? '音频素材' : (isVideo(value) ? '视频素材' : '文件素材') }}</span>
      <el-button type="text" icon="el-icon-close" @click="clear" size="mini">清除</el-button>
    </div>

    <el-dialog title="上传素材" :visible.sync="uploadVisible" width="400px" append-to-body>
      <el-form label-width="80px" size="small">
        <el-form-item label="素材名"><el-input v-model="uploadForm.name" /></el-form-item>
        <el-form-item label="分类">
          <el-select v-model="uploadForm.category"><el-option label="角色" value="character" /><el-option label="怪物" value="enemy" /><el-option label="武器" value="weapon" /><el-option label="坦克" value="tank" /><el-option label="道具" value="item" /><el-option label="背景" value="background" /><el-option label="特效" value="effect" /><el-option label="音效" value="sound" /><el-option label="其他" value="other" /></el-select>
        </el-form-item>
        <el-form-item label="素材"><ImageUpload v-model="uploadForm.url" :accept="accept" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="uploadVisible=false">取消</el-button><el-button type="primary" @click="doUpload" :loading="uploading">保存到素材库</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import api from '../api'
export default {
  props: {
    value: { type: String, default: '' },
    accept: { type: String, default: '' }
  },
  data() { return { materials: [], selectedUrl: this.value, uploadVisible: false, uploading: false, uploadForm: { name: '', url: '', category: 'other' }, materialLoadSerial: 0 } },
  computed: {
    filteredMaterials() {
      var type = String(this.accept || '').toLowerCase()
      if (!type) return this.materials
      return this.materials.filter(m => type === 'image' ? this.isImage(m.url) : (type === 'audio' ? this.isAudio(m.url) : (type === 'video' ? this.isVideo(m.url) : true)))
    }
  },
  watch: { value(v) { this.selectedUrl = v } },
  created() { this.loadMaterials() },
  activated() { this.loadMaterials() },
  methods: {
    isImage(url) { return /\.(png|jpg|jpeg|gif|webp|svg)(?:[?#].*)?$/i.test(String(url || '')) },
    isAudio(url) { return /\.(mp3|wav|m4a|ogg)(?:[?#].*)?$/i.test(String(url || '')) },
    isVideo(url) { return /\.(mp4|webm|mov|m4v)(?:[?#].*)?$/i.test(String(url || '')) },
    async loadMaterials() { const serial = ++this.materialLoadSerial; const r = await api.getMaterials({ page: 1, pageSize: 2000, _t: Date.now() }); if (serial === this.materialLoadSerial && r.data.code === 0) this.materials = r.data.data.list || []; },
    onVisibleChange(visible) { if (visible) this.loadMaterials() },
    onSelect(v) { this.$emit('input', v || '') },
    clear() { this.selectedUrl = ''; this.$emit('input', '') },
    showUpload() {
      var type = String(this.accept || '').toLowerCase()
      this.uploadForm = { name: '', url: '', category: type === 'image' ? 'background' : (type === 'audio' ? 'sound' : 'other') }
      this.uploadVisible = true
    },
    async doUpload() {
      if (!this.uploadForm.url) { this.$message.warning('请先上传素材'); return }
      this.uploading = true
      await api.saveMaterial(this.uploadForm)
      this.uploading = false; this.uploadVisible = false
      this.$emit('input', this.uploadForm.url)
      this.selectedUrl = this.uploadForm.url
      this.$message.success('素材已保存')
      this.loadMaterials()
    }
  }
}
</script>

<style scoped>
.picker-row { display: flex; gap: 8px; align-items: center; }
.preview-row { margin-top: 8px; display: flex; align-items: center; gap: 8px; }
.material-preview-image { width: 60px; height: 60px; border-radius: 6px; border: 1px solid #eee; background: #f5f7fa; cursor: zoom-in; }
.material-preview-error { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: #909399; font-size: 11px; text-align: center; }
.material-file-preview { min-width: 60px; height: 32px; padding: 0 8px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px; border: 1px solid #eee; background: #f5f7fa; color: #606266; font-size: 12px; }
</style>
